import * as React from "react";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { Emotions } from "source/app/domain/Emotions/Emotions";

export function ShowHighStateCount({
    value,
    suffix,
}: {
    value: number;
    suffix: string;
}) {
    if (value === 0) {
        return <span />;
    }

    const color = Emotions.GetFromCharacter(suffix).hexColor;
    const tooltip = GetTooltip(value);

    return (
        <span
            className={StyleClassAuto({
                color,
            })}
        >
            {value}
            <span
                className={StyleClassAuto({
                    opacity: 0.7,
                    position: `relative`,
                    top: `2px`,
                    left: `1px`,
                })}
                data-tip={tooltip}
            >
                {suffix}
            </span>
        </span>
    );
}

function GetTooltip(value: number) {
    const valuePerDay = parseFloat((value / 365.25).toFixed(2));
    const valuePerWeek = parseFloat((value / 52).toFixed(2));
    const tooltip = `${valuePerDay} per day | ${valuePerWeek} per week`;
    return tooltip;
}

